export class PDFila {
    propiedad = 'prop';
    valor: string;


}
